export var RecordingMode;
(function (RecordingMode) {
    RecordingMode[RecordingMode["None"] = 0] = "None";
    RecordingMode[RecordingMode["Video"] = 1] = "Video";
    RecordingMode[RecordingMode["Audio"] = 2] = "Audio";
})(RecordingMode || (RecordingMode = {}));
